import React, { useEffect, useState } from "react";

import Flickity from "flickity";
import "flickity/css/flickity.css";
import "./Supporting.scss";
import illustationLeft from "../../assets/images/illustrationLeft.png";
import illustationRight from "../../assets/images/illustrationRight.png";
import card1 from "../../assets/images/Card 1.png";
import card2 from "../../assets/images/Card 2.png";
import card3 from "../../assets/images/Card 3.png";
import card1mob from "../../assets/images/card1mob.png";
import card2mob from "../../assets/images/card2mob.png";
import card3mob from "../../assets/images/card3mob.png";
import card4 from "../../assets/images/Card 4.png";
import { motion, useTransform, useViewportScroll } from "framer-motion";

function Supporting() {
  const [isMob, setisMob] = useState(false);
  useEffect(() => {
    var elem = document.querySelector(".carousel");
    var flkty = new Flickity(elem, {});
  }, []);
  const [delay, setdelay] = useState(0.18);
  useEffect(() => {
    if (window.innerWidth < 991) {
      setdelay(0);
    } else {
      setdelay(0.18);
    }

    if (window.innerWidth < 456) {
      setisMob(true);
    } else {
      setisMob(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 991) {
        setdelay(0);
      } else {
        setdelay(0.18);
      }

      if (window.innerWidth < 456) {
        setisMob(true);
      } else {
        setisMob(false);
      }
    });
  });
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, delay], [0.8, 1]);
  const opacity = useTransform(scrollYProgress, [0, delay], [0.6, 1]);
  return (
    <section className="support-carousels">
      <div className="container">
        <motion.div
          className="support-title-container"
          style={{ scale, opacity }}
        >
          <img src={illustationLeft} alt="" className="s-title-left" />
          <div className="support-title upheav">
            Supporting Builders, DAOs & Ideas To change the way we play in the
            Metaverse
          </div>
          <img src={illustationRight} alt="" className="s-title-right" />
        </motion.div>
      </div>

      <div className="carousel">
        <div className="carouselitem">
          <img src={isMob ? card1mob : card1} alt="" />
        </div>
        <div className="carouselitem">
          <img src={isMob ? card2mob : card2} alt="" />
        </div>
        <div className="carouselitem">
          <img src={isMob ? card3mob : card3} alt="" />
        </div>
      </div>
    </section>
  );
}

export default Supporting;
